import request from './core/request'
import API_DOMAINS from './core/config'

// 用户相关API（包含登录注册）
export default {
	//获取隐私条款、用户协议、关于我们
	getPrivacyAgreement: (type, langCode) => request.get(`/setting/privacyAgreement/current/${type}/${langCode}`, {}, {
		baseURL: API_DOMAINS.manager,
		needAccessToken: false
	}),
	// 获取语言列表
	getLanguage: () => request.get('/setting/i18n/languages/active', {}, {
		baseURL: API_DOMAINS.manager,
		needAccessToken: false
	}),
	//检查邮箱是否已存在
	checkEmail: (email) => request.get(`/passport/member/check/email`, {
		email
	}, {
		needAccessToken: false
	}),
	// 获取国家列表数据
	getCountryCode: () => request.get('/countryCode', {}, {
		baseURL: API_DOMAINS.common,
		needAccessToken: false
	}),
	//发送注册验证码到邮箱
	sendRegisterEmail: (verificationEnums, email) => request.get(`common/email/${verificationEnums}/${email}`, {}, {
		baseURL: API_DOMAINS.common,
		needAccessToken: false
	}),
	//验证邮箱验证码
	checkEmailCode: (data) => request.post('/common/email/code/check', data, {
		baseURL: API_DOMAINS.common,
		needAccessToken: false
	}),
	//验证邮箱验证码（用于找回密码）
	resetEmailCode: (data) => request.post('/passport/member/email/reset/code', data, {
		needAccessToken: false,
		formData: true,
	}),
	//注册 - 邮箱注册
	userRegiest: (data) => request.post('/passport/member/email/register', data, {
		needAccessToken: false,
		formData: true
	}),
	//账号密码登录
	userLogin: (data) => request.post('/passport/member/userLogin', data, {
		formData: true,
		clientType: 'APP'
	}),
	//获取登录用户信息
	getUserInfo: () => request.get('/passport/member', {}, {}),
	//退出登录
	logout: () => request.post('/passport/member/logout', {}, {
		formData: true
	}),
	//重置密码（找回密码）
	resetPassword: (data) => request.post('/passport/member/email/resetPassword', data, {
		needAccessToken: false,
	}),
	//修改个人资料
	editUser: (data) => request.put(
		`/passport/member/editOwn?nickName=${data.nickName}&sex=${data.sex}&face=${data.face}&countryCode=${data.countryCode}&remark=${data.remark}`, {}, {}
		)
}